import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ElementName } from '../../../../../constants';
import { useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import { BaseTextElement, toTextProps } from '../common';
var SourceBranchElement = function SourceBranchElement(props) {
  var context = useFlexibleUiContext();
  var data = context ? toTextProps(context.sourceBranch) : null;
  return data ? /*#__PURE__*/React.createElement(BaseTextElement, _extends({}, data, props, {
    name: ElementName.SourceBranch
  })) : null;
};
export default SourceBranchElement;